import { useQuery } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { ApiError, OtelStatusResponse } from '../types/showcase';

/**
 * GET /api/eraf/showcase/demo/otel/status — C072 OpenTelemetry 관측 status 조회
 * 계약: docs/common-specs/eraf-actuator/C072-opentelemetry.md §Δ.4
 * queryKey: ['common-showcase', 'otel', 'status']
 *
 * ★ C055(Kafka)/C054(Mongo) 처럼 왕복 발행·저장 폼이 없다 — 이 호출 자체가 span 을
 * 생성하므로, [상태 새로고침] 을 누를 때마다 recentTraceId 가 바뀌는 것 자체가 시연이다.
 * staleTime 을 두지 않아 재호출 시 항상 신선한 traceId 를 받는다.
 */
export function useOtelStatus() {
  return useQuery<OtelStatusResponse, ApiError>({
    queryKey: ['common-showcase', 'otel', 'status'],
    queryFn: () => showcaseApi.otelStatus(),
  });
}
